<template>
  <div class="coupon-list">
    <ul v-if="couponList.length">
      <li v-for="coupon in couponList" :key="coupon.id">
        <div class="coupon-box" @click="getCoupon(coupon)">
          <div v-if="coupon.redPackedStatus != '立即领取'" class="can-not-pick-mask"></div>
          <!-- <img src="//image01.homedo.com/Files/Images/cms/www/20210507/5341613134763904140_pic1.png" alt="" /> -->
          <div class="coupon-detail">
            <div class="coupon-left">
              <div class="line-height-control" style="margin-left: -0.5rem">
                <span class="coupon-type">{{ couponTypeMap[coupon.redAmountType] }}</span>
                <span class="left-count">{{ coupon.redPackedCountDesc }}</span>
              </div>
              <div class="line-height-control reduce-money">
                <span>{{ coupon.redAmount }}</span>元
              </div>
              <div class="line-height-control">
                <!-- <span v-if="renderData.full > 0" class="full-money">满100元可用</span> -->
                <span class="full-money">{{ coupon.redPackedExplain }}</span>
              </div>
              <div class="line-height-control">
                <span class="use-range">{{ coupon.redAmountRuleDesc }}</span>
              </div>
            </div>
            <div class="get-btn">
              <span>{{ coupon.redPackedStatus }}</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { getRedPacketList, getUsePackage } from '../../../request/search.js'
let vm = null
export default {
  props: { categoryid: '', keyword: '' },
  data() {
    return {
      userInfo: {},
      couponList: [],
      couponTypeMap: {
        1: '红包',
        2: '服务券',
        3: '运费券',
        4: '红包',
        5: '红包',
        6: '红包',
      },
    }
  },
  computed: {
    paramsData() {
      const { categoryid, keyword } = this
      return {
        categoryid,
        keyword,
        accountId: (this.userInfo && this.userInfo.AccountId) || '',
      }
    },
  },
  watch: {
    paramsData: {
      handler(newVal, oldVal) {
        if (newVal.categoryid != oldVal.categoryid || newVal.keyword != oldVal.keyword || newVal.accountId != oldVal.accountId) {
          vm.getCouponList()
        }
      },
      deep: true,
    },
  },
  created() {
    vm = this
    $HMD$.GetLogin(function (data) {
      vm.userInfo = data
    })
    this.getCouponList()
  },
  methods: {
    getCouponList() {
      getRedPacketList({
        accountId: vm.userInfo && vm.userInfo.AccountId,
        categoryId: vm.categoryid,
        keyword: vm.keyword,
      }).then((res) => {
        const { data, respCode } = res.data
        if (data && respCode == '0000') {
          vm.couponList = (data && data.slice(0, 5)) || []
          vm.$emit('judgeshow', vm.couponList)
          const params = {
            content_type: '红包',
            package_num: vm.couponList.length,
            $search_keyword: vm.keyword,
          }
          $HMD$.aYiGuan('natural_search_result_display', null, params)
        }
      })
    },
    //领取红包
    getCoupon(coupon) {
      if (coupon.redPackedStatus != '立即领取') {
        return false
      }
      this.countClick(coupon)
      if (!vm.userInfo.AccountId) {
        location.href = `${$HMD$.rapi.M}/Account/Login?url=${location.href}`
        return false
      }
      getUsePackage({
        accountId: (vm.userInfo && vm.userInfo.AccountId) || '',
        packetId: coupon.id,
        type: coupon.redAmountType,
      }).then((res) => {
        const { respCode } = res.data
        if (respCode == '0000') {
          vm.getCouponList()
          $HMD$.Prop('领取成功')
        }
      })
    },
    countClick(coupon) {
      const params = {
        content_type: '红包',
        package_id: coupon.id,
        package_name: '',
      }
      $HMD$.aYiGuan('search_result_click', null, params)
    },
  },
}
</script>
<style scoped>
.coupon-list {
  padding: 0 0.3rem;
}
.coupon-list ul {
  display: flex;
  overflow-x: auto;
}
.coupon-box {
  display: inline-flex;
  position: relative;
  font-size: 1.2rem;
  background: url(//image01.homedo.com/Files/Images/cms/www/20210507/5341613134763904140_pic1.png) no-repeat;
  background-size: 100% 101%;
  margin-left: 0.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.can-not-pick-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 2;
}
.coupon-detail {
  display: flex;
  width: 16.5rem;
  height: 8rem;
}
.coupon-left {
  flex: 1;
  padding: 0.5rem 1rem;
}
.full-money {
  color: #f1504f;
}
.use-range {
  color: #7d7f88;
}
.get-btn {
  font-size: 1.2rem;
  line-height: normal;
  text-align: center;
  width: 2rem;
  display: flex;
  align-items: center;
}
.get-btn span {
  display: inline-block;
  color: #fff;
  width: 1.8rem;
  font-size: 1.1rem;
  line-height: 1.3rem;
}

.coupon-type {
  background: linear-gradient(270deg, #ffad4a 0%, #fe8139 100%);
  border-radius: 0.3rem;
  color: #fff;
  display: inline-block;
  box-sizing: border-box;
  text-align: center;
  padding: 0.2rem 0.3rem;
}
.left-count {
  color: #ff7f15;
  font-size: 1.2rem;
  display: inline-block;
  margin-left: 1.5rem;
}
.line-height-control {
  line-height: 1.4rem;
  font-size: 1rem;
}
.reduce-money {
  font-size: 1.2rem;
  color: #f1504f;
  line-height: 2rem;
  margin-top: 0.5rem;
}
.reduce-money span {
  font-size: 2rem;
  font-weight: 600;
  margin-right: 0.3rem;
}
</style>